import { router, store } from "@/main";
import * as setting_types from "@/store/constants/setting_types";
import {
  getLaunchRecommendOffer,
  isCanshowFreeFollow,
  isShowAppOutOfStock
} from "./util";
import Event_bus from "@/utils/event_bus";

import { goToDoubleCoin } from "@/utils/router_helper";
import { isDoubleCoins } from "@/utils/general_utils";
import * as types from "@/store/constants/index_types";
// import { showUpgradeApp } from "@/services/dialog_utils";
import { RedirectApp } from "@/services/open_pop_up/types";

const init_logic = async function*() {
  try {
    // 开机导量
    // const showRedirect: boolean | undefined = await isShowAppOutOfStock();
    // if (showRedirect) {
    //   const redirect_app: RedirectApp =
    //     store.getters[setting_types.GETTER_REDIRECT_APP];
    //   yield showUpgradeApp(redirect_app);
    // }
    // free follow
    if (await isCanshowFreeFollow()) {
      yield Event_bus.$emit("is_show_free_follow", true);
    }
    // 当前是否有ins账户
    const currentId: null | string =
      store.getters[types.GETTER_CURRENT_USER_ID];
    /*
     * 最后一级有三种选择，优先级是 double > feature > recommend
     * */
    if (isDoubleCoins()) {
      goToDoubleCoin();
    } else {
      // 根据权重随机推荐
      const recommendOffer = await getLaunchRecommendOffer();
      console.log("recommendOffer", recommendOffer);
      if (!recommendOffer) {
        return;
      }
      Event_bus.$emit("show_launch_recommend", {
        show: true,
        offer: recommendOffer
      });
    }
  } catch (e) {
    //
  }
};

const generator = init_logic();
export default generator;
